import giftApi from '../api/giftApi';
import Gift from '../models/gift';
import { IApiResponse } from '../interfaces/IApiResponse';

class GiftService {
  getListGifts(): Promise<{ success: boolean; data: Gift[] }> {
    return giftApi.getListGifts().then((res: IApiResponse) => {
      let data: any[] = [];
      try {
        if (res.success) {
          data = Gift.mappingGifts(res.data?.items);
        } else {
          console.log('ERROR: GiftService/getListGifts:', res.message);
        }
        return { success: res.success, data };
      } catch (e) {
        console.log('ERROR: GiftService/getListGifts:', e);
        throw new Error('failed');
      }
    });
  }

  giveGift(userId: string | number, consumablePriceID: string | number): Promise<IApiResponse> {
    return giftApi.giveGift(userId, consumablePriceID).then((res: IApiResponse) => {
      return {
        ...(res || {}),
        success: res?.success,
        data: {
          giftId: res?.data?.GiftID,
          remainingCredits: res?.data?.RemainingCredits,
        },
      } as IApiResponse;
    });
  }

  getGiftsReceived(): Promise<{ success: boolean; data: Gift[] }> {
    return giftApi.getGiftsReceived().then((res: IApiResponse) => {
      try {
        return { success: true, data: Gift.mappingGifts(res.data?.items) };
      } catch (e) {
        console.log('ERROR: getGiftsReceived', e);
        throw new Error('failed');
      }
    });
  }

  getGiftReplies(): Promise<{ success: boolean; data: string[] }> {
    return giftApi.getGiftReplies().then((res: IApiResponse) => {
      try {
        // return { success: true, data: Gift.mappingGifts(res.data.items) };
        console.log('res', res);
        return { success: res.success, data: res.data?.items };
      } catch (e) {
        console.log('ERROR: getGiftReplies', e);
        throw new Error('failed');
      }
    });
  }

  redeemReceivedGift(giftId: string | number): Promise<IApiResponse> {
    return giftApi.redeemReceivedGift(giftId).then((res: IApiResponse) => {
      try {
        return res;
      } catch (e) {
        console.log('ERROR: redeemReceivedGift', e);
        throw new Error('failed');
      }
    });
  }

  forfeitReceivedGift(giftId: string | number): Promise<{ success: boolean }> {
    return giftApi.forfeitReceivedGift(giftId).then((res: IApiResponse) => {
      try {
        return { success: res?.success };
      } catch (e) {
        console.log('ERROR: forfeitReceivedGift', e);
        throw new Error('failed');
      }
    });
  }
}

export default new GiftService();
